import { Button } from "antd";
import React, { useState } from "react";
import ModalCreateAccount from "../modal/ModalCreateAccount";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonCreateAccountProps {
  // Add props here
}

const ButtonCreateAccount: React.FC<ButtonCreateAccountProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);  useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button
        size="large"
        onClick={showModal}
        className="font-medium"
        type="primary"
      >
        Tạo tài khoản
      </Button>
      <ModalCreateAccount onClose={handleCancel} visible={isModalOpen} />
    </div>
  );
};

export default ButtonCreateAccount;
